import Cookies from 'js-cookie';
import wpGeodirServices from "services/wpGeodirServices";

const redirectUrl = (url: string) => {
    window.open(url, "_blank");
    Cookies.remove('redirectId');
    Cookies.remove('catId');
}

export const redirectProgram = async (Id: string, categoryId:any) => {
    try {
        if (Id && categoryId && Id.length>0 && categoryId.length>0) {
            const body = {
                id: Id,
                catId: categoryId
            };
            let url:string  = await wpGeodirServices.getPostPage(body) ?? '';
            if (url) {
                redirectUrl(`${url}?registed=true`);
            }
        }
    }
    catch(ex){
        console.log('Error: ', ex);
    }

}
